import { GameTicketSymbolProperties } from "@lib/js-slingo-pawnshop-core/dist/game/view/abstract/properties/GameTicketSymbolProperties";
import { GameFontStyle } from "@lib/js-slingo-pawnshop-core/dist/game/view/abstract/style/GameFontStyle";
import { GameStyle } from "@lib/js-slingo-pawnshop-core/dist/game/view/abstract/style/GameStyle";
import { FontStyle } from "@lib/titan2-slingo/dist/game/view/abstract/style/FontStyle";
import { ControlConstants } from "@lib/titan2/dist/game/control/constant/ControlConstants";
import { BitmapTextFieldProperties } from "@lib/titan2/dist/game/control/properties/BitmapTextFieldProperties";
import { ButtonProperties } from "@lib/titan2/dist/game/control/properties/ButtonProperties";
import { SpriteProperties } from "@lib/titan2/dist/game/control/properties/SpriteProperties";
import * as PIXI from "pixi.js";
import { BitmapFontStyles } from "../../../font/FontConstants";
import { GameTextUtil } from "@lib/js-slingo-pawnshop-core/dist/game/utils/GameTextUtils";
/**
 * TicketSymbolLandscapeProperties.ts
 */
export class TicketSymbolLandscapeProperties extends GameTicketSymbolProperties {
    setDefaultValues() {
        super.setDefaultValues();
        this.size = new PIXI.Point(180, 180);
        this.spineProperties.position = new PIXI.Point(92, 92);
        const textTargetPosition = new PIXI.Point(0, -20);
        this.buttonProperties = new ButtonProperties(null, null);
        this.buttonProperties.hitArea = new PIXI.Rectangle(10, 10, 160, 160);
        this.symbolFieldProperties = new BitmapTextFieldProperties(BitmapFontStyles.TICKET_SYMBOL, FontStyle.TICKET_SYMBOL, textTargetPosition.clone(), undefined, ControlConstants.CENTER, ControlConstants.CENTER);
        this.symbolFieldProperties.size = new PIXI.Point(180, 180);
        this.symbolHighlightFieldProperties = new BitmapTextFieldProperties(BitmapFontStyles.TICKET_SYMBOL_DAB_HIGHLIGHT, FontStyle.TICKET_SYMBOL_DAB_HIGHLIGHT, textTargetPosition.clone(), undefined, ControlConstants.CENTER, ControlConstants.CENTER);
        this.symbolHighlightFieldProperties.size = new PIXI.Point(180, 180);
        this.symbolHighlightWildFieldProperties = new BitmapTextFieldProperties(BitmapFontStyles.TICKET_SYMBOL_WILD_HIGHLIGHT, FontStyle.TICKET_SYMBOL_DAB_HIGHLIGHT, textTargetPosition.clone(), undefined, ControlConstants.CENTER, ControlConstants.CENTER);
        this.symbolHighlightWildFieldProperties.size = new PIXI.Point(180, 180);
        this.symbolHighlightSuperWildFieldProperties = new BitmapTextFieldProperties(BitmapFontStyles.TICKET_SYMBOL_SUPER_WILD_HIGHLIGHT, GameFontStyle.TICKET_SYMBOL_SUPER_DAB_HIGHLIGHT, textTargetPosition.clone(), undefined, ControlConstants.CENTER, ControlConstants.CENTER);
        this.symbolHighlightSuperWildFieldProperties.size = new PIXI.Point(180, 180);
        this.backgroundProperties = new SpriteProperties("TicketSymbol", GameStyle.MODULE, new PIXI.Point(0, 0));
        [
            this.symbolFieldProperties,
            this.symbolHighlightFieldProperties,
            this.symbolHighlightWildFieldProperties,
            this.symbolHighlightSuperWildFieldProperties,
        ].forEach((x) => {
            GameTextUtil.centerProperties(x);
        });
    }
}
